import { useEffect, useState } from "react";
import { onAuthStateChanged } from "firebase/auth";
import { ref, onValue } from "firebase/database";
import { auth, database } from "../firebase";
import "../styles/dashboard.css";
import { FaUser, FaEnvelope, FaCalendarAlt, FaPhone, FaGlobe, FaTransgender } from "react-icons/fa";

const Profile = () => {
  const [userData, setUserData] = useState(null);

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, (user) => {
      if (user) {
        const userRef = ref(database, "users/" + user.uid);
        onValue(userRef, (snapshot) => {
          if (snapshot.exists()) {
            setUserData(snapshot.val());
          }
        });
      }
    });

    return () => unsubscribe();
  }, []);

  return (
    <div style={styles.wrapper}>
      <div style={styles.profileCard}>
        <h2 style={styles.title}>User Profile</h2>
        {userData ? (
          <div style={styles.detailsContainer}>
            <ProfileItem icon={<FaUser />} label="Name" value={userData.name} />
            <ProfileItem icon={<FaEnvelope />} label="Email" value={userData.email} />
            <ProfileItem icon={<FaCalendarAlt />} label="Date of Birth" value={userData.dob} />
            <ProfileItem icon={<FaTransgender />} label="Gender" value={userData.gender} />
            <ProfileItem icon={<FaGlobe />} label="Country" value={userData.country} />
            <ProfileItem icon={<FaPhone />} label="Phone" value={userData.phone} />
            <div style={styles.item}>
              <span style={styles.icon}>🎯</span>
              <span style={styles.label}>Interests:</span>
              <ul style={styles.list}>
                {userData.interests?.map((interest, idx) => (
                  <li key={idx} style={styles.listItem}>{interest}</li>
                ))}
              </ul>
            </div>
          </div>
        ) : (
          <p style={styles.loading}>Loading your profile...</p>
        )}
      </div>
    </div>
  );
};

const ProfileItem = ({ icon, label, value }) => (
  <div style={styles.item}>
    <span style={styles.icon}>{icon}</span>
    <span style={styles.label}>{label}:</span>
    <span style={styles.value}>{value}</span>
  </div>
);

export default Profile;

const styles = {
  wrapper: {
    minHeight: "100vh",
    padding: "60px 20px",
    background: "linear-gradient(145deg, #F3EBFF, #ffffff)",
    display: "flex",
    justifyContent: "center",
    alignItems: "flex-start",
  },
  profileCard: {
    background: "#ffffff",
    borderRadius: "16px",
    boxShadow: "0 12px 32px rgba(0,0,0,0.12)",
    padding: "40px 32px",
    maxWidth: 800,
    width: "100%",
    animation: "fadeIn 0.8s ease-in-out",
  },
  title: {
    fontSize: 30,
    fontWeight: 800,
    color: "#15007d",
    marginBottom: 30,
    textAlign: "center",
    letterSpacing: 1,
    textTransform: "uppercase",
    background: "linear-gradient(to right, #8F27FF, #15007d)",
    WebkitBackgroundClip: "text",
    WebkitTextFillColor: "transparent",
  },
  detailsContainer: {
    display: "flex",
    flexDirection: "column",
    gap: 20,
  },
  item: {
    display: "flex",
    alignItems: "center",
    gap: 12,
    background: "#F9F6FF",
    padding: "16px 20px",
    borderRadius: 12,
    border: "1px solid #e0dbff",
    boxShadow: "0 2px 10px rgba(143, 39, 255, 0.06)",
  },
  icon: {
    fontSize: 20,
    color: "#8F27FF",
  },
  label: {
    fontWeight: "600",
    fontSize: 16,
    color: "#444",
    minWidth: 140,
  },
  value: {
    fontSize: 16,
    color: "#222",
    flex: 1,
  },
  list: {
    listStyleType: "disc",
    paddingLeft: 20,
    margin: 0,
  },
  listItem: {
    fontSize: 15,
    color: "#333",
    marginTop: 4,
  },
  loading: {
    textAlign: "center",
    fontSize: 18,
    fontWeight: "500",
    color: "#15007d",
    animation: "pulse 1.5s ease-in-out infinite",
  },
};
